import classNames from 'classnames';
import { type ComponentPropsWithoutRef, memo, type ReactNode, useCallback, useState } from 'react';

export type ContentCollectionSidebarProps = ComponentPropsWithoutRef<'div'> & {
  renderCollapsibleHeader?: (props: { isCollapsed: boolean; onToggleCollapse: () => void }) => ReactNode;
};

export const ContentCollectionSidebar = memo(
  ({ children, className, renderCollapsibleHeader, ...restOfProps }: ContentCollectionSidebarProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const onToggleCollapse = useCallback(() => {
      setIsCollapsed((prev) => !prev);
    }, []);

    return (
      <div className={classNames('flex-shrink-0 p-4 md:h-full', className)}>
        {!!renderCollapsibleHeader && renderCollapsibleHeader({ isCollapsed, onToggleCollapse })}
        <aside
          className={classNames(
            'flex flex-col gap-4 rounded-8 ads:bg-base bg-gray-1 p-6 md:h-full md:w-[360px] md:overflow-y-auto',
            isCollapsed && 'hidden',
          )}
          {...restOfProps}
        >
          {children}
        </aside>
      </div>
    );
  },
);

ContentCollectionSidebar.displayName = 'ContentCollectionSidebar';
